import { useEffect } from 'react'
import { useLocation } from 'react-router'

export const ScrollToTop = () => {
  const { pathname, state } = useLocation()

  useEffect(() => {
    if (state && typeof state === 'object' && 'preventScrollReset' in state && state.preventScrollReset) {
      return
    }
    // Scroll to top whenever the route changes
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
  }, [pathname, state])

  return null // This component doesn't render anything
}
